var React = require('react');

function Left (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.0862 13L11 23.5839L21.0862 34.5354","stroke":"black"}));
}

Left.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Left;

Left.default = Left;
